import { TextAreaField } from '@aws-amplify/ui-react'
import { List } from '@mui/icons-material'
import { Box, Stack } from '@mui/material'
import type { FormEvent, RefCallback } from 'react'
import { useTranslation } from 'react-i18next'

import CustomButton from '@/components/inputs/CustomButton'

const LIST_TEXT_FIELD_NAME = 'listText'

type ControllerListImporterProps = {
  /** The list as text. Whenever it changes, the text being edited starts again from it */
  listText: string
  onUpdate: (text: string) => void
  /** Called with the text field each time it is mounted, also when it starts again from a changed list */
  textFieldRef?: RefCallback<HTMLTextAreaElement>
}

export function ControllerListImporter({ listText, onUpdate, textFieldRef }: Readonly<ControllerListImporterProps>) {
  const { t } = useTranslation()

  function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault()
    const listTextValue = new FormData(event.currentTarget).get(LIST_TEXT_FIELD_NAME)
    onUpdate(typeof listTextValue === 'string' ? listTextValue : '')
    // Shows the list as it was cleaned up, also when that's the list already shown and the field isn't started again
    event.currentTarget.reset()
  }

  return (
    <Stack component="form" direction="column" spacing={1} onSubmit={handleSubmit}>
      {/* The browser holds the text being edited. Keyed on the list, so only the field starts again from it */}
      <TextAreaField
        key={listText}
        ref={textFieldRef}
        defaultValue={listText}
        label={t('controllers.bulk_actions.importer')}
        name={LIST_TEXT_FIELD_NAME}
        placeholder={t('controllers.bulk_actions.importer_placeholder')}
      />
      <Box>
        <CustomButton color="primary" startIcon={<List />} type="submit" variant="contained">
          {t('controllers.bulk_actions.importer_update_list')}
        </CustomButton>
      </Box>
    </Stack>
  )
}
